<template>
	<div class="filter-popup-container" v-if="visible">
		<!-- 遮罩层 -->
		<div class="popup-mask" @click="handleMaskClick"></div>
		<!-- 弹窗主体 -->
		<div class="popup-content">
			<!-- 头部 -->
			<div class="popup-header">
				<div style="flex: 1;"></div>
				<div class="popup-title">全部筛选</div>

				<div class="close-btn" style="flex: 1;" @click="handleClose">
					<div style="flex: 1;"></div>
					<div class="close-icon">x</div>
				</div>
			</div>

			<!-- 搜索栏 -->
			<div class="search-bar">
				<div class="search-input-box">
					<input class="search-input" placeholder-style="color: #595AEC" placeholder="请搜索关键字"
						:value="searchKeyword" @input="handleSearch" />
					<img class="search-icon" src="@/assets/images/report/1@2x(2).png" @click="handleSearchBtn"/>
				</div>
			</div>

			<!-- 主体内容 -->
			<div class="popup-body">
				<!-- 左侧分类列表 -->
				<div class="category-list">
					<div v-for="(category, index) in categories" :key="index" class="category-item"
						:class="activeCategory == category.categoryId?'category-name-active':'category-name'"
						@click="handleCategoryChange(category)">
						<div v-if="activeCategory == category.categoryId" class="category-dot"></div>
						<div class="category-name"
							:class="activeCategory == category.categoryId?'category-name-active':'category-name'">{{ category.category }}</div>
					</div>
				</div>

				<!-- 右侧选项列表 -->
				<div class="options-list">
					<div v-for="(option, index) in currentOptions" :key="index" class="option-item"
						:class="{ selected: option.seleted }" @click="handleOptionSelect(option)">
						<div class="option-name">{{ option.name }}</div>
					</div>
				</div>
			</div>

			<!-- 底部按钮 -->
			<div class="popup-footer">
				<div class="footer-btn cancel-btn" @click="handleCancel">
					<div class="btn-div">取消</div>
				</div>
				<div class="footer-btn confirm-btn" @click="handleConfirm">
					<div class="btn-div">保存</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getdashboardSetting } from '@/api/login';
import { handleLocalStorage } from '@/utils';


	export default {
		name: 'filterPopupVue',
		props: {
			// 是否显示弹窗
			visible: {
				type: Boolean,
				default: false
			},
		},

		data() {
			return {
				activeCategory: '',
				searchKeyword: '',
				selectedOptions: {},
				categories: [],
				copyCategories: [],
				currentOptions: [],
			}
		},
		created() {
			this.initData()
		},

		methods: {
			// 初始化数据
			initData() {
				this.getdashboardSettingdata()
				// 设置默认分类
				if (this.categories.length > 0) {
					this.activeCategory = this.categories[0].categoryId
					this.currentOptions = this.categories[0].childen
				}
				// 重置搜索
				this.searchKeyword = ''
			},

			// 切换分类
			handleCategoryChange(category) {
				this.activeCategory = category.categoryId
				this.currentOptions = category.childen
				// 切换分类时重置搜索
			},

            handleSearchBtn(){
				
			},
			// 搜索处理
			handleSearch(e) {
				this.searchKeyword = e.target.value
				const tempCategories = JSON.parse(JSON.stringify(this.copyCategories))
				tempCategories.filter((mode, index) => {
					const childen = []
					mode.childen.filter((item, j) => {
						 if((item.name+'').includes(this.searchKeyword)){
							childen.push(item) 
						 }
					})
					mode.childen = childen
					tempCategories[index] = mode
				})
				this.categories =tempCategories
				const category =this.categories.find(mode=>mode.categoryId===this.activeCategory)
				this.currentOptions  =category?category.childen:[]
			},

			// 选择/取消选择选项
			handleOptionSelect(option) {
				const seleted = !option.seleted
				this.categories.filter((mode, index) => {
					if (mode.categoryId == this.activeCategory) {
						if (option.Id == 'all') {
							mode.childen.filter((item, j) => {
								item.seleted = seleted
								mode.childen[j] = item
							})
						} else {
							mode.childen.filter((item, j) => {
								if (item.Id == option.Id) {
									item.seleted = seleted
								}
								mode.childen[j] = item
							})
						}
					}
					this.categories[index] = mode
				})
				
				this.copyCategories.filter((mode, index) => {
					if (mode.categoryId == this.activeCategory) {
						if (option.Id == 'all') {
							mode.childen.filter((item, j) => {
								item.seleted = seleted
								mode.childen[j] = item
							})
						} else {
							mode.childen.filter((item, j) => {
								if (item.Id == option.Id) {
									item.seleted = seleted
								}
								mode.childen[j] = item
							})
						}
					}
					this.copyCategories[index] = mode
				})	
			},

			// 点击遮罩层
			handleMaskClick() {
				// 可选：点击遮罩是否关闭
				this.handleClose()
			},

			// 关闭弹窗
			handleClose() {
				this.$emit('update:visible', false)
				this.$emit('close')
			},

			// 取消按钮
			handleCancel() {
				// 恢复之前的选中状态
				this.handleClose()
			},

			// 确认按钮
			handleConfirm() {
				// 更新备份状态
				handleLocalStorage.set("ReportConfi", JSON.stringify(this.copyCategories))
				// 触发确认事件，返回所有选中项
				this.$emit('confirm', '')
				this.$emit('update:visible', false)
			},
			getdashboardSettingdata() { // 报表显示设置
				const result = getdashboardSetting()
				
				const jsonString = handleLocalStorage.get('ReportConfi');
				if (!jsonString || (jsonString + '').length < 3000) {
					handleLocalStorage.set('ReportConfi', JSON.stringify(result))
					this.categories.push(...result)
				} else {
					this.categories.push(...JSON.parse(jsonString))
				}
				this.copyCategories.push(...this.categories)
			},
			
		}
	}
</script>

<style scoped>
	/* 弹窗容器 */
	.filter-popup-container {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 9999;
	}

	/* 遮罩层 */
	.popup-mask {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
	}

	/* 弹窗主体 */
	.popup-content {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		height: 80vh;
		background: #ffffff;
		display: flex;
		flex-direction: column;
		border-radius: 24px 24px 0 0;
		animation: slideUp 0.3s ease;
	}

	@keyframes slideUp {
		from {
			transform: translateY(100%);
		}

		to {
			transform: translateY(0);
		}
	}

	/* 头部 */
	.popup-header {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 24px 30px;
		border-bottom: 2px solid #f0f0f0;
	}

	.popup-title {
		width: auto;
		display: flex;
		font-size: 32px;
		text-align: center;
		font-weight: 600;
		color: #39395C;
	}

	.close-btn {
		width: 48px;
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.close-icon {
		font-size: 64px;
		color: #8989AD;
		line-height: 1;
	}

	/* 搜索栏 */
	.search-bar {
		padding: 20px 30px;
		border-bottom: 2px solid #f0f0f0;
	}

	.search-input-box {
		display: flex;
		align-items: center;
		background: #f5f7fa;
		border-radius: 8px;
		padding: 16px 20px;
	}

	.search-icon {
		width: 28px;
		height: 28px;
		margin-right: 12px;
	}

	.search-input {
		flex: 1;
		font-size: 28px;
		color: #595AEC;
		background-color: transparent;
		border-color: transparent;
		border-width: 0px;

	}



	/* 主体内容 */
	.popup-body {
		flex: 1;
		display: flex;
		overflow: hidden;
	}

	/* 左侧分类列表 */
	.category-list {
		width: 200px;
		background: #f5f7fa;
		overflow-y: auto;
	}

	.category-item {
		display: flex;
		height: 80px;
		text-align: center;
		align-items: center;
	}

	.category-name {
		width: 100%;
		font-size: 28px;
		height: 80px;
		background: #f5f7fa;
		line-height: 80px;
		text-align: center;
		color: #666666;
	}

	.category-name-active {
		background: #ffffff;
	}

	.category-dot {
		margin-left: 24px;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		background: #ff6b6b;
	}

	/* 右侧选项列表 */
	.options-list {
		flex: 1;
		padding: 24px;
		overflow-y: auto;
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
		gap: 20px;
	}

	.option-item {
		min-width: 140px;
		max-width: 200px;
		padding: 16px 32px;
		border: 2px solid #B2B2C0;
		border-radius: 16px;
		background: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.3s ease;
	}

	.option-item.selected {
		background-color: rgba(89, 90, 236, 0.06);
		border: 2px solid #595AEC;
	}

	.option-name {
		background-color: #ffffff;
		font-size: 24px;
		color: #39395C;

	}

	.option-item.selected .option-name {
		background-color: rgba(89, 90, 236, 0.06);
		color: #595AEC;
	}

	/* 底部按钮 */
	.popup-footer {
		display: flex;
		gap: 20px;
		padding: 20px 30px;
		border-top: 2px solid #f0f0f0;
		padding-bottom: 80px;
		background: #ffffff;
	}

	.footer-btn {
		flex: 1;
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 40px;
		font-size: 32px;
	}

	.cancel-btn {
		background: #ffffff;
		border: 2px solid #595AEC;
	}

	.cancel-btn .btn-div {
		color: #595AEC;
	}

	.confirm-btn {
		background: #595AEC;
	}

	.confirm-btn .btn-div {
		color: #ffffff;
	}
</style>